import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Button from '@atlaskit/button/standard-button';
import ChevronDownIcon from '@atlaskit/icon/utility/migration/chevron-down';
export var PopupTrigger = function PopupTrigger(_ref) {
  var triggerProps = _ref.triggerProps,
    isSelected = _ref.isSelected,
    labelPrefix = _ref.labelPrefix,
    selectedLabel = _ref.selectedLabel,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, _extends({}, triggerProps, {
    testId: 'confluence-search-modal--date-range-button',
    onClick: onClick,
    isSelected: isSelected,
    iconAfter:
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
      LEGACY_size: "medium",
      label: "",
      color: "currentColor"
    }))
  }), labelPrefix, selectedLabel ? ": ".concat(selectedLabel) : '');
};